import { useDateTime } from "../../../../../../localization/useDateTime"
import { useEffect, useState } from "react"
import { DateTime } from "luxon"
import { Box } from "@mui/material"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()(() => ({
    progressBarBackground: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "4px",
        backgroundColor: "#D1FAE5",
    },
    progressBar: {
        position: "absolute",
        top: 0,
        left: 0,
        height: "4px",
        backgroundColor: "#059669",
        transition: "width 0.5s ease-in-out",
    },
}))

export function MeetingProgressBar({ start, end }: { start: string; end: string }) {
    const { classes } = useStyles()

    const dateTimeFactory = useDateTime()
    const [progress, setProgress] = useState(0)
    const [progressVisible, setProgressVisible] = useState(false) // Hide progress bar for future meetings

    useEffect(() => {
        const now = DateTime.now()
        const meetingStart = dateTimeFactory.fromApi(start)
        const meetingEnd = dateTimeFactory.fromApi(end)

        if (now < meetingStart) {
            setProgress(0)
            setProgressVisible(false)
        } else if (now >= meetingStart && now <= meetingEnd) {
            const totalDuration = meetingEnd.diff(meetingStart, "minutes").minutes
            const elapsed = now.diff(meetingStart, "minutes").minutes
            const progressPercentage = Math.min((elapsed / totalDuration) * 100, 100)

            setProgress(progressPercentage)
            setProgressVisible(true)
        } else {
            setProgress(100)
            setProgressVisible(true)
        }
    }, [start, end, dateTimeFactory])
    return (
        <>
            <Box className={classes.progressBarBackground} />

            {progressVisible && <Box className={classes.progressBar} style={{ width: `${progress}%` }} />}
        </>
    )
}
